<p-timeline [value]="onlyParadas" [layout]="'vertical'" styleClass="timeline-regulares ">
    <ng-template pTemplate="marker" let-event>
        <span class="shadow-2 p-timeline-event-marker font-semibold">
            {{event.numorden}}
        </span>
    </ng-template>
    <ng-template pTemplate="content" let-item>
        {{ item?.horapaso }}
        <ng-container *ngIf="item?.horapaso && item?.nomParada"> - </ng-container>
        {{ item?.nomParada }}
    </ng-template>
</p-timeline>